import { render, staticRenderFns } from "./VeiculoFilterBar.vue?vue&type=template&id=b98d45a2"
import script from "./VeiculoFilterBar.vue?vue&type=script&lang=js"
export * from "./VeiculoFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports